<template>
<div :class="['modal is-active', {'show': come_in}]" v-if="show">
    <div class="modal-background" @click.prevent="close"></div>
    <div class="modal-content">
        <article :class="['message', 'is-' + msg_type]">
            <div class="message-header">
                <p>{{title}}</p>
            </div>
            <div class="message-body has-text-centered" v-if="is_html"><div class="content" v-html="content"></div></div>
            <div class="message-body has-text-centered" v-else><p>{{content}}</p></div>
            <div class="message-foot has-text-centered">
                <button :class="['button', 'is-' + msg_type]" @click.prevent="close">OK</button>
            </div>
        </article>
    </div>
</div>
</template>

<script>
export default {
    name    :   'MessageModal',
    data() {
        return {
            show        :   false,
            come_in     :   false,
            title       :   'Message',
            content     :   null,
            is_html     :   false,
            msg_type    :   'success'
        }
    },
    created() {
        let me  =   this;
        this.$bus.$on('onShowMessage', (msg, type, title) => {
            me.show     =   true;
            me.is_html  =   /^/.test(msg);
            me.title    =   title ? title : me.title;
            me.content  =   msg;
            me.msg_type =   type ? type : me.msg_type;
        });
    },
    watch   :   {
        show(nv, ov) {
            let me  =   this;
            if (nv) {
                setTimeout(function () {
                    me.come_in  =   true;
                }, 0);
                $(window).bind('keydown', me.keydown_handler);
            }
        },
        come_in(nv, ov) {
            let me  =   this;
            if (!nv) {
                setTimeout(function () {
                    me.show     =   false;
                    me.title    =   'Message';
                    me.content  =   null;
                    me.msg_type =   'success';
                }, 0);
                $(window).unbind('keydown', me.keydown_handler);
            }
        }
    },
    methods :   {
        keydown_handler(e) {
            if (e.keyCode == 13 || e.keyCode == 27) {
                this.close();
            }
        },
        close() {
            this.come_in    =   false;
            this.$bus.$emit('onCloseMessage');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/MessageModal.vue